/* action type */
import type { Action } from '../../store/state/state-manager';

export const DELETE_CASE_IN_CREATE_STAGE = 'DELETE_CASE_IN_CREATE_STAGE';

/* action creator */
export const deleteCaseInCreateStageAction = (actionPayload: Action['payload']) => {
  return {
    type: DELETE_CASE_IN_CREATE_STAGE,
    payload: actionPayload
  };
};
